<template>
  <div class="rightContent">
    <el-table
      stripe
      :data="tableData"
      border
      style="width: 100%"
      height="100%"
      size="mini"
      @sort-change="sortChange"
    >
      <el-table-column
        type="index"
        :width="pagination.endIndex >= 1000 ? 80 : 50"
        align="center"
        :index="pagination.beginIndex"
      ></el-table-column>
      <el-table-column prop="version" label="版本号" min-width="110px" align="center" show-overflow-tooltip sortable="version" >
        <template slot-scope="scope">
        <span class="textOverflow allowSkip" style="white-space:pre !important;" v-if="scope.row.version" @click="VersionClickBtn($event, scope.row)">
          {{ scope.row.version }}
        </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="build"
        label="构建号"
        min-width="110px"
        align="center"
        show-overflow-tooltip
        sortable="build"
      ></el-table-column>
      <el-table-column
        prop="type"
        label="固件类型"
        min-width="110px"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.type">{{ scope.row.type.title }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="publisher"
        label="发布方"
        min-width="100px"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="customerId"
        label="定制客户"
        min-width="110px"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.customer">{{ scope.row.customer.name }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="publishDate"
        label="发布日期"
        min-width="110px"
        align="center"
        show-overflow-tooltip
        sortable="custom"
      ></el-table-column>
      <el-table-column
        prop="uploadUser"
        label="上传人"
        min-width="110px"
        align="center"
        show-overflow-tooltip
      >      
        <template slot-scope="scope">
          <span v-if="scope.row.uploadUser" class="textOverflow">{{ scope.row.uploadUser.name }} ({{ scope.row.uploadUser.employeeNum }})</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态" width="95px"
        align="center"
        show-overflow-tooltip
        sortable="custom"
      >
        <template slot-scope="scope">
          <span :class="{danger: scope.row.status.code == 'Deprecated'}" v-if="scope.row.status" class="textOverflow">{{scope.row.status.title}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="操作" width="95px"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.status && scope.row.status.code=='RC'" class="allowSkip" style="margin-right:10px;" @click="releaseFw(scope.row)">发布</span>
          <span v-if="scope.row.status && (scope.row.status.code=='RC' || scope.row.status.code=='Release')" class="allowSkip" @click="disableFw(scope.row)">禁用</span>
          <span v-if="scope.row.status && scope.row.status.code=='Deprecated'" class="allowSkip" @click="rollbackFw(scope.row)">还原</span>
          <span v-if="!scope.row.status">-</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :pagination="pagination"
      @currentChange="currentChange"
      @sizeChange="sizeChange"
      @refreshBtn="getFirmwareSearch"
    ></pagination>    
    <myDrawer ref="myDrawer" :drawerOption="drawerOption"></myDrawer>
    <myDialog ref="myDialog" :title="dialogTitle"
      @submitData="submitData" @dialogClose="dialogClose" width="650px">
      <template slot="content">
        <el-form ref="dialogForm"
          :model="dialogForm" :rules="dialogRules" :label-width="labelWidth">
          <el-form-item label="版本号" size="small" prop="version" class="inlineItem">
            <el-input v-model="dialogForm.version"
              placeholder="如：V1.0.1.10" clearable></el-input>
          </el-form-item>
          <el-form-item label="构建号" size="small" prop="build" class="inlineItem">
            <el-input :value="dialogForm.build"
              placeholder="如：20191113" @input="formatInputInt($event, 'dialogForm', 'build')" clearable></el-input>
          </el-form-item>
          <el-form-item label="固件类型" size="small" prop="type" class="inlineItem">
            <el-select v-model="dialogForm.type"
              placeholder="选择固件类型" filterable clearable>
              <el-option v-for="(item, index) in $parent.pullDownData.firmwareTypeList"
                :key="index" :label="item.title" :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发布方" size="small" prop="publisher" class="inlineItem">
            <el-select v-model="dialogForm.publisher"
              placeholder="选择发布方" filterable clearable>
              <el-option v-for="(item, index) in $parent.pullDownData.publisherList"
                :key="index" :label="item.title" :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="物料编码" size="small" prop="itemCode" class="inlineItem">
            <el-input v-model="dialogForm.itemCode" placeholder="贴片元器件的物料编码" clearable></el-input>
          </el-form-item>
          <el-form-item label="位置号" size="small" prop="position" class="inlineItem">
            <el-input v-model="dialogForm.position" placeholder="贴片的位置号" clearable></el-input>
          </el-form-item>
          <el-form-item label="全量包" size="small" prop="imageFile" class="inlineItem">
            <input type="file" ref="imageFile" class="fileUpload" @change="fileChange('imageFile')"/>
          </el-form-item>
          <el-form-item label="全量包MD5" size="small" prop="imageMd5" class="inlineItem">
            <el-input v-model="dialogForm.imageMd5" placeholder="全量包MD5" clearable></el-input>
          </el-form-item>
          <el-form-item label="升级包" size="small" prop="upgradeFile" class="inlineItem">
            <input type="file" ref="upgradeFile" class="fileUpload" @change="fileChange('upgradeFile')"/>
          </el-form-item>
          <el-form-item label="升级包MD5" size="small" prop="upgradeMd5" class="inlineItem">
            <el-input v-model="dialogForm.upgradeMd5"
              placeholder="升级包的MD5校验值" clearable></el-input>
          </el-form-item>
          <el-form-item label="问题清单" size="small" prop="ISSUEFile" class="inlineItem">
            <input type="file" ref="ISSUEFile" class="fileUpload" @change="fileChange('ISSUEFile')"/>
          </el-form-item>
          <el-form-item label="" size="small" prop="" class="inlineItem"></el-form-item>
          <el-form-item label="定制客户" size="small" prop="customerId" class="inlineItem">
            <el-select v-model="dialogForm.customerId" placeholder="选择客户名称" filterable clearable>
              <el-option v-for="(item, index) in $parent.pullDownData.customerList"
                :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发布日期" size="small" prop="publishDate" class="inlineItem">
            <el-date-picker v-model="dialogForm.publishDate"
              type="date" placeholder="固件发布日期" value-format="yyyy-MM-dd" :picker-options="$store.state.pickerOptions"></el-date-picker>
          </el-form-item>
          <el-form-item label="发行说明" size="small" prop="releaseNotes">
            <el-input v-model="dialogForm.releaseNotes"
              type="textarea" :rows="4" placeholder="描述版本更新说明"></el-input>
          </el-form-item>
        </el-form>
      </template>
    </myDialog>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import myDialog from "@/components/myDialog.vue";
import myDrawer from "@/components/myDrawer.vue";
import {
  apiFirmwareSearch,
  // apiFirmwareTypeList,
  // apiPublisherList,
  // apiCustomerList
  apiProductList,
  apiFirmwareAdd,
} from "@/api/firmwareManage.js";
import { apiUploadFile } from "@/api/filesUpload";
export default {
  components: {
    pagination,
    myDrawer,
    myDialog,
  },
  props: {
    tabPaneValue: {
      type: String,
    },
    firmwareSearchForm: {
      type: Object,
    },
  },
  data() {
    return {
      tableData: [],
      drawerOption: {},
      pullDownData: {
        productList: [],
      },
      desc: undefined,
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10,
      },
      dialogTitle: "",
      dialogForm: {},
      dialogRules: {
        version: [
          { required: true, message: "版本号不能为空！", trigger: "blur" },
        ],
        build: [
          { required: true, message: "构建号不能为空！", trigger: "blur" },
        ],
        type: [
          { required: true, message: "固件类型不能为空！", trigger: "change" },
        ],
        publisher: [
          { required: true, message: "发布方不能为空！", trigger: "change" },
        ],
        imageFile: [
          { required: true, message: "全量包不能为空！", trigger: "blur" },
        ],
        imageMd5: [
          { required: true, message: "固件包MD5不能为空！", trigger: "blur" },
          {
            min: 16,
            max: 256,
            message: "长度在 16 到 256 个字符",
            trigger: "change",
          },
        ],
        upgradeMd5: [
          {
            min: 16,
            max: 256,
            message: "长度在 16 到 256 个字符",
            trigger: "change",
          },
        ],
        releaseNotes: [
          { required: true, message: "发行说明不能为空！", trigger: "blur" },
          {
            min: 10,
            message: "长度在 10 个字符以上",
            trigger: "change",
          },
        ],
        // product_type: [
        //   { required: true, message: "产品类别不能为空！", trigger: "blur" },
        //   {
        //     min: 2,
        //     max: 64,
        //     message: "长度在 2 到 64 个字符",
        //     trigger: "change",
        //   },
        // ],
        // product_id: [
        //   { required: true, message: "内部型号不能为空！", trigger: "blur" },
        //   {
        //     min: 2,
        //     max: 64,
        //     message: "长度在 2 到 64 个字符",
        //     trigger: "change",
        //   },
        // ],
      },
      labelWidth: this.$store.state.labelWidth,
    };
  },
  methods: {
    releaseFw(data) {
      this.$refs.myDrawer.releaseFw(data)
    },
    disableFw(data) {
      this.$refs.myDrawer.disableFw(data)
    },
    rollbackFw(data) {
      this.$refs.myDrawer.rollbackFw(data)
    },
    // 表格数据
    async getFirmwareSearch(remove, callback) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      const res = await apiFirmwareSearch({
        productId: this.tabPaneValue,
        ...this.firmwareSearchForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        orderBy: this.orderBy,
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
        if (callback) callback();
      }
    },    
    // 点击版本列
    VersionClickBtn(e, row) {
      e.target.blur();
      this.drawerOption = {
        versionId: row.id,
        version: row.version,
        type: 'version'
      }
      this.$nextTick(() => {
        this.$refs.myDrawer.getVersion();
      })
    },
    // 新建版本
    addNewBtn() {
      this.dialogTitle = "发布版本";
      this.$refs.myDialog.dialogVisible = true;
    },
    // 确认新建
    submitData(title) {
      this.$refs.dialogForm.validate(async (valid) => {
        if (valid) {
          if (title == "发布版本") {
            // imageFile upgradeFile ISSUEFile
            // console.log(this.dialogForm);
            let uploadArr = ["imageFile", "upgradeFile", "ISSUEFile"];
            let uploadRes = {};
            for (let item of uploadArr) {
              if (this.dialogForm[item]) {
                let fd = new FormData();
                fd.append("file", this.dialogForm[item]);
                uploadRes = await apiUploadFile(fd);
                if (uploadRes.code == 0) {
                  this.$set(
                    this.dialogForm,
                    item.split("File").join("Fid"),
                    uploadRes.fid
                  );
                }
              }
            }
            const res = await apiFirmwareAdd({
              productId: this.tabPaneValue,
              ...this.dialogForm,
              build: +this.dialogForm.build,
              imageFile: undefined,
              upgradeFile: undefined,
              ISSUEFile: undefined,
            });
            // console.log("文件请求完毕");
            if (res.code == 0) {
              this.$refs.myDialog.dialogVisible = false;
              this.getFirmwareSearch();
              this.$message({
                message: "发布成功",
                type: "success"
              })
            }
          }
        } else {
          return false;
        }
      });
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.dialogForm.resetFields();
      this.dialogForm = {};
      this.$refs.imageFile.value = "";
      this.$refs.upgradeFile.value = "";
      this.$refs.ISSUEFile.value = "";
    },
    // 清除查询
    onClear() {
      this.pagination.currentPage = 1;
      this.getFirmwareSearch();
    },
    // 确认查询
    onSearch() {
      this.pagination.currentPage = 1;
      this.getFirmwareSearch();
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getFirmwareSearch();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getFirmwareSearch();
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getFirmwareSearch();
    },
    // 发布版本-产品类别改变
    productTypeChange(value) {
      this.$set(this.dialogForm, "productId", null);
      this.pullDownData.productList = [];
      if (value) {
        this.getProductList(value, "productList");
      }
    },
    // 产品型号下拉
    async getProductList(productType, name) {
      const res = await apiProductList({
        productType
      });
      if (res.code == 0) {
        this.pullDownData[name] = res.data;
      }
    },
    // 判断只能输入数字
    formatInputInt(value, formName, keyName) {
      this.$set(this[formName], keyName, this.$formatPositive(value));
    },
    // 发布版本-文件上传
    async fileChange(refName) {
      this.$set(this.dialogForm, refName, this.$refs[refName].files[0]);
      this.$refs.dialogForm.validateField(refName);
      // console.log(file)
    },
  },
};
</script>

<style>
</style>